import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { TutorialProvider } from './context/TutorialContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <TutorialProvider>
    <App />
  </TutorialProvider>
  //</React.StrictMode>
);

